import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Outlet,
  Route,
  RouterProvider
} from 'react-router-dom';
import { NotFound } from './NotFound';
import { Admin } from './admin';
import { RequireAuthentication } from './auth/RequireAuthentication';
import { MfaChallenge } from './auth/views/MfaChallenge';
import { SignInCallback } from './auth/views/SignIn';
import { VerifyEmail } from './auth/views/VerifyEmail';
import { Clinics } from './clinics';
import { FeatureFlagModal } from './components/FeatureFlagModal';
import { Layout } from './components/app';
import { Home } from './home';
import { Patients } from './patients';
import { isDev, isStaging } from './util/env';

import 'rsuite/Animation/styles/index.css';
import 'rsuite/DateRangePicker/styles/index.css';
import 'rsuite/Message/styles/index.css';
import 'rsuite/Tag/styles/index.css';
import 'rsuite/TagPicker/styles/index.css';
import 'rsuite/Toggle/styles/index.css';
import 'rsuite/toaster/styles/index.css';
import 'rsuite/useToaster/styles/index.css';

import { Internal } from './internal/Internal';
import './styles.css';

export const App = () => {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route>
        <Route element={<RequireAuthentication />}>
          <Route
            element={
              <Layout>
                <Outlet />
              </Layout>
            }
          >
            <Route path="/" element={<Home />} />
            <Route path="/patients/*" element={<Patients />} />
            <Route path="/clinics/*" element={<Clinics />} />
            <Route path="/admin/*" element={<Admin />} />
            <Route path="/internal/*" element={<Internal />} />
            <Route path="*" element={<NotFound />} />
          </Route>

          <Route path="/verify-email" element={<VerifyEmail />} />
        </Route>

        <Route path="sign-in" element={<Navigate to="/" replace />} />
        <Route path="sign-in/callback" element={<SignInCallback />} />
        <Route path="sign-in/mfa" element={<MfaChallenge />} />
      </Route>
    )
  );

  return (
    <div className="flex h-full w-full md:justify-center">
      <RouterProvider router={router} />
      {(isDev || isStaging) && <FeatureFlagModal />}
    </div>
  );
};
